<template>
  <Layout>
    <div class="d-flex reset-password-container justify-content-center align-items-center">
      <b-card class="reset-password-box">
        <h3 class="mb-4">Change Password</h3>

        <div class="mb-4">
          Don't have an account yet? 
          <a style="color: rgba(var(--bs-link-color-rgb)); cursor: pointer;" @click="showAccountUnavailable">Create your account</a>
        </div>

        <div class="mb-4">
          Your Kanto Ads password can be reset by clicking the button bellow. If you did not request a new password. Please ignore this emails.
        </div>

        <b-form-group
          class="mb-4"
        >
          <label>New Password</label>
          <b-form-input placeholder="Enter New Password" v-model="newPassword" trim type="password"></b-form-input>
        </b-form-group>

        <b-form-group
          class="mb-4"
        >
          <label>Confirm Password</label>
          <b-form-input placeholder="Confirm Password" v-model="confirmPassword" trim type="password"></b-form-input>
        </b-form-group>

        <b-button class="w-100" variant="primary">Change Password</b-button>
      </b-card>
      <account-creation-unavailable-modal ref="accountModal" />
    </div>
  </Layout>
</template>

<script>
import Layout from "../../layouts/main.vue";
import AccountCreationUnavailableModal from '@/components/AccountCreationUnavailableModal.vue';

export default {
  components: {
    Layout,
    AccountCreationUnavailableModal,
  },
  data() {
    return {
      newPassword: null,
      confirmPassword: null,
    };
  },
  methods: {
    showAccountUnavailable() {
      if (this.$refs && this.$refs.accountModal && typeof this.$refs.accountModal.show === 'function') {
        this.$refs.accountModal.show();
      }
    },
  },
};
</script>

<style>
.reset-password-box {
  width: 493px;
  border-radius: 8px;
}

.reset-password-box .card-body {
  padding: 24px;
}

.reset-password-box label {
  font-weight: 500;
  font-family: 'Poppins';
}

.reset-password-container {
  height: 80vh;
}

.reset-password-container h3 {
  font-family: 'Poppins';
}

.red {
  color: #FF0000;
}
</style>